import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { GraphNodeSubdomainEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import { Alert } from "~/components-shared";
import apiTokenSelectors from "~/store/apiTokens/selectors";
import NodeForm from "~/forms/NodeForm";
import nodeSchema from "~/forms/NodeForm/nodeSchema";
import api from "~/lib/api";
import { handleError } from "~/lib/helpers";
import toastsActionCreators from "~/store/toasts/actions";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const KnowledgeGraphCreateNodeModal = _ref => {
  let {
    onClose,
    onCreated
  } = _ref;
  const {
    t
  } = useTranslation();
  const action = useSelector(apiTokenSelectors.getAction);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const dispatch = useDispatch();
  const defaultValues = {
    name: "",
    subdomain: GraphNodeSubdomainEnum.CUSTOMER,
    keywords: ""
  };
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch
  } = useForm({
    resolver: yupResolver(nodeSchema),
    defaultValues
  });
  useEffect(() => {
    if (!action) {
      reset(defaultValues);
    }
  }, [action]);
  const onSubmit = handleSubmit(data => {
    setLoading(true);
    setError(undefined);
    api.createGraphNode(data).then(node => {
      if (node) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("KnowledgeGraphCreateNodeModal.nodeCreated", {
            name: node.name
          }),
          timeout: 10000
        }));
        onClose();
        onCreated(node);
      }
    }).catch(e => setError(handleError(e))).finally(() => setLoading(false));
  });
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("KnowledgeGraphCreateNodeModal.createNode"),
    onClose: onClose,
    maxWidth: "560px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(NodeForm, {
    control: control,
    setValue: setValue,
    watch: watch
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onClose,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: loading,
    fullWidth: true,
    rounded: true
  }, t("KnowledgeGraphCreateNodeModal.saveNode")))));
};
export default KnowledgeGraphCreateNodeModal;